<template v-if="getGameConsole === 'default'">
  <v-expand-transition v-if="postSkin === 0" id="expand-cart">
    <div
      class="fixed-cart"
      v-if="getGameConsole === 'default' && getBetOdds.length > 0"
      @click="openCart"
    >
      <div class="count-odds">
        <span class="d-flex-center-all count">{{ getBetOdds.length }}</span>
      </div>
      <div class="type">
        <span class="d-flex-center-all bet-type"
          >{{ ($t(getBet.type) + ':') | capitalize }}
          <span class="winning">{{ getWinning(getBet) }}</span></span
        >
      </div>
      <div class="action">
        <v-icon>mdi-chevron-up</v-icon>
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FixedCart',
  data: () => ({
    postSkin: 0,
  }),
  components: {},
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getId: 'user/getId',
      getLogin: 'user/getLogin',
      getBet: 'cart/getBet',
      getBetOdds: 'cart/getBetOdds',
      getSettings: 'cart/getSettings',
      getGameConsole: 'settings/getGameConsole',
      getLiveMode: 'odds/getLiveMode',
    }),
  },
  watch: {
    async getBetOdds() {
      await this.refreshCart()
      this.$root.$emit('forceUpdateSystem')
      this.$root.$emit('forceUpdateSingleMultiple')
      this.$root.$emit('forceUpdateIntegral')
      this.postChartValue(
        this.getBetOdds.length,
        this.$t(this.getBet.type),
        this.getWinning(this.getBet)
      )
    },
  },
  methods: {
    ...mapActions({
      setLiveMode: 'odds/setLiveMode',
      refreshCart: 'cart/refreshCart',
    }),
    receiveMessage(event) {
      if (event.data.type == 'postSkin') {
        this.postSkin = event.data.postSkin
      } else {
        this.postSkin = 0
      }
      if (event.data.type == 'openCarrello') {
        this.openCart()
        this.postSkin = 1
      }

      //
      // if(this.getGameConsole==='marketview'){
      //   console.log('sending message to handle func')
      //   this.handleMessage(event);
      // }

      // console.log(event)
      // console.log(event.data.type)
    },
    postChartValue(value, typeBet, winning) {
      window.parent.postMessage(
        {
          type: 'counterChart',
          counterChart: value,
          typeBet: typeBet,
          winning: winning,
        },
        '*'
      )
    },
    getWinning(bet) {
      const currencySymbol = this.getSettings.currencySymbol
      switch (bet.type) {
        case 'single':
        case 'multiple':
          return (
            currencySymbol +
            ' ' +
            parseFloat(bet._multiple_detail.winning_total).toFixed(2)
          )
        case 'integral':
          return (
            currencySymbol +
            ' ' +
            parseFloat(bet._integral_detail.winning_total_max).toFixed(2)
          )
        case 'system':
          return (
            currencySymbol +
            ' ' +
            parseFloat(bet._system_detail.winning_all_total).toFixed(2)
          )
      }
    },

    openCart() {
      this.$root.$emit('cart_handling', true)
    },

    // /* TODO MOVE THIS LISTENER IN ANOTHER COMPONENT */
    // handleMessage(event) {
    //
    //   console.log('handle message function')
    //   console.log(event)
    //
    //   if (event != null && event.data != null && event.data.type != null) {
    //
    //     switch (event.data.type) {
    //
    //
    //       case 'openHomeSportPage':
    //         console.log('event received openHomeSportPage');
    //         this.$root.$emit('set_live_mode_preview_and_reset_state', true);
    //         break;
    //
    //       case 'openSportPage':
    //         console.log('event received openSportPage');
    //         this.$root.$emit('set_live_mode_preview', true);
    //         break;
    //
    //       case 'openLiveSportPage':
    //         console.log('event received openLiveSportPage');
    //         this.$root.$emit('set_live_mode_detail', true);
    //         break;
    //
    //       case 'toggleSportCart':
    //         console.log('event received for toggle sport cart');
    //         this.$root.$emit('cart_handling', true);
    //         this.sendModeMessageToSkin();
    //         break;
    //
    //       case 'openSportTree':
    //         console.log('event received for openSportTree');
    //         this.$root.$emit('open_sidebar_left', true);
    //         break;
    //     }
    //   }
    // },
    // sendModeMessageToSkin(){
    //   const vm = this;
    //   window.parent.postMessage({
    //     'type': 'sportMode',
    //     'mode': vm.getLiveMode,
    //   }, "*");
    // }
  },

  mounted() {
    this.postChartValue(
      this.getBetOdds.length,
      this.$t(this.getBet.type),
      this.getWinning(this.getBet)
    )
    window.addEventListener('message', this.receiveMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage)
  },
}
</script>

<style scoped>
.fixed-cart {
  overflow: hidden;
  width: 97% !important;
  position: fixed !important;
  overflow-y: auto;
  height: 40px;
  font-size: 14px;
  font-weight: 700;
  background: var(--fixed-cart-bg);
  display: flex;
  bottom: 2%;
  align-content: center;
  padding: 0 2% !important;
  border-radius: 8px;
  z-index: 1;
}

.count-odds,
.type {
  display: flex;
  align-items: center;
}

.count-odds .count {
  background: #1e1e1e;
  padding: 2px 10px;
  border-radius: 10px;
}

.type .bet-type {
  margin-left: 10px;
  color: #1e1e1e;
  font-weight: 500;
}

.type .winning {
  color: #1e1e1e;
  font-weight: 800;
  margin-left: 10px;
}

.fixed-cart .action {
  margin-left: auto;
  display: flex;
}

.fixed-cart .action i {
  color: #1e1e1e !important;
}
</style>
